import { useLocation, useMatches } from '@tanstack/react-router'
import type pages from '@/utils/i18n-to-migrate/pages.no.json'

type PageKeys = keyof typeof pages

interface Crumb {
  path: string
  name: PageKeys
}

export function useTSRBreadCrumbs(): { breadcrumb_routes: Crumb[] } {
  const matches = useMatches()

  const location = useLocation()
  const fromSearch = location.state.fromSearch

  const breadcrumbs: Crumb[] = []

  // Add search breadcrumb if coming from search (but not if we're currently on the search page)
  const isOnSearchPage = location.pathname === '/search'
  if (fromSearch && !isOnSearchPage) {
    const searchUrl = `/search?${new URLSearchParams(fromSearch as string).toString()}`
    breadcrumbs.push({
      path: searchUrl,
      name: 'search',
    })
  }
  breadcrumbs.push(
    ...matches
      .filter((match) => match.pathname !== '/')
      .map((match) => {
        const name = match.staticData.breadcrumb ?? match.pathname
        return {
          path: match.pathname,
          name: name as PageKeys,
        }
      })
      .filter(Boolean),
  )

  return { breadcrumb_routes: breadcrumbs }
}
